import { useEffect } from "react";

const SITE_NAME = "Infinitiv";

/**
 * Sets the document title and meta description for the current page.
 * The site name is appended automatically: "About Us | Infinitiv".
 * Pass { brandFirst: true } for "Infinitiv | tagline" (home page).
 * Pass an empty title to use the bare site name.
 */
export default function usePageMeta(title, description, { brandFirst = false } = {}) {
  useEffect(() => {
    if (!title) document.title = SITE_NAME;
    else if (brandFirst) document.title = `${SITE_NAME} | ${title}`;
    else document.title = `${title} | ${SITE_NAME}`;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description, brandFirst]);
}
